export default class Queue {
  constructor(maxSize) {
    this.queue = [];
    this.maxSize = maxSize;
  }
  enqueue(item) {
    if (this.queue.length === this.maxSize) {
      return false;
    }
    this.queue.push(item);
    return true;
  }
  flush(callback) {
    this.queue.forEach(callback);
    this.queue = [];
  }
  getSize() {
    return this.queue.length;
  }
}